import React from 'react'
import AlertDialog from '../../../../../components/AlertDialog/index.es6'
import { CircularProgress } from '@material-ui/core'

const DeleteClaimNote = (props) => {
  const handleDeleteNote = () => {
    const payload = {
      "claim_guid": props.claimGuid,
      "notes_guid": props.note.guid
    }
    console.log("delete notes payload", payload)
    props.onDelete(payload)
  }

  const handleNoteDeletedSuccessfully = () => {
    props.resetDeleteNotesSuccessAlert()
    props.onClose()
    window.location.reload()
  }

  const handleNoteDeleteError = () => {
    props.resetDeleteNotesErrorAlert()
  }

  return (
    <>
      <AlertDialog
        custom
        show={props.showDeleteNoteProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2>Deleting Claim Note...</h2>
      </AlertDialog>

      <AlertDialog
        success
        show={props.showDeleteNotesSuccessAlert}
        size="sm"
        title={'Claim note deleted'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { handleNoteDeletedSuccessfully() }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={true}
        cancelBtnText={'cancel'}
        confirmBtnCssClass
      >
      </AlertDialog>

      <AlertDialog
        show={props.showDeleteNotesErrorAlert}
        danger
        title={'Error deleting claim note'}
        onConfirm={() => handleNoteDeleteError()}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >
        {props.DeleteNotesError ? props.DeleteNotesError.message : ''}
      </AlertDialog>

      <AlertDialog
        show={props.open && !props.showDeleteNoteProgressAlert && !props.showDeleteNotesSuccessAlert && !props.showDeleteNotesErrorAlert}
        danger
        title={'Delete Claim Note'}
        onConfirm={handleDeleteNote}
        onCancel={props.onClose}
        confirmBtnText={'Delete'}
        cancelBtnText={'Cancel'}
        confirmBtnCssClass
        showCancel={true}
        style={{ marginTop: '0', top: '30vh' }}
      >
        <div>
          Are you sure you want to delete this note?
          <br /><br />
          <strong>Description:</strong> {props.note && props.note.description}
          <br />
          <strong>Text:</strong> {props.note && props.note.text && props.note.text.substring(0, 100)}{props.note && props.note.text && props.note.text.length > 100 ? '...' : ''}
        </div>
      </AlertDialog>
    </>
  )
}

export default DeleteClaimNote